import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, FileText, CheckCircle, Database, Archive, Layers } from 'lucide-react';


export default function WorkspaceHistory() {
  const navigate = useNavigate();

  const historyModules = [
    {
      id: 'invoice',
      title: 'Histori Invoice',
      description: 'Arsip daftar invoice yang sudah lunas dan selesai, beserta total akumulasi pendapatan.',
      icon: FileText,
      color: 'text-amber-600',
      bg: 'bg-amber-100',
      border: 'border-amber-200',
      path: '/office/workspace/history-invoices'
    },
    {
      id: 'purchasing',
      title: 'Histori Pembelian',
      description: 'Arsip daftar PO Purchasing yang barangnya sudah tiba dan pembayarannya lunas.',
      icon: Package,
      color: 'text-green-600',
      bg: 'bg-green-100',
      border: 'border-green-200',
      path: '/office/workspace/history-purchasing'
    },
    {
      id: 'client-po',
      title: 'Histori PO Client',
      description: 'Arsip SPK / PO dari klien yang proses produksinya sudah selesai 100%.',
      icon: CheckCircle,
      color: 'text-blue-600',
      bg: 'bg-blue-100',
      border: 'border-blue-200',
      path: '/office/workspace/history-client-po'
    }
  ];

  return (
    <div className="flex flex-col h-full bg-[#f9f9f9]">
      <div className="bg-white border-b border-[#E6D5B8] p-6 shadow-sm">
        <h1 className="text-2xl font-black text-[#302621]">Gudang Arsip (History)</h1>
        <p className="text-[#8C6208] text-sm font-semibold mt-1">Daftar arsip data yang sudah selesai dari seluruh departemen.</p>
      </div>

      <div className="flex-1 p-6 md:p-8 overflow-y-auto">
        <div className="max-w-6xl mx-auto space-y-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl md:text-3xl font-black text-slate-800 tracking-tight flex items-center gap-3">
                <Archive className="w-8 h-8 text-[#8C6208]" />
                Workspace Archive
              </h1>
              <p className="text-slate-500 mt-2 text-sm md:text-base max-w-2xl">
                Pilih modul di bawah ini untuk melihat riwayat data yang sudah terselesaikan. 
                Data di sini tidak lagi muncul di tabel utama operasional.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {historyModules.map((mod) => (
              <div 
                key={mod.id}
                onClick={() => navigate(mod.path)}
                className={`group p-6 rounded-3xl bg-white border ${mod.border} shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer hover:-translate-y-1 relative overflow-hidden`}
              >
                <div className={`w-14 h-14 rounded-2xl ${mod.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <mod.icon className={`w-7 h-7 ${mod.color}`} />
                </div>
                
                <h3 className="text-xl font-bold text-slate-800 mb-2">{mod.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed mb-6">
                  {mod.description}
                </p>

                <div className="flex items-center text-[#8C6208] text-sm font-semibold group-hover:translate-x-2 transition-transform duration-300">
                  Lihat Arsip →
                </div>

                <Database className="absolute -bottom-6 -right-6 w-32 h-32 text-slate-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}
